import tools from '../tools';

const PathBehaviors = {
  // Paths only support uniform scaling.
  uniformScaling: true,

  cornerStyle: 'circle',
  transparentCorners: false,

  _controlsVisibility: {
    mt: false,
    mb: false,
    ml: false,
    mr: false,
  },

  tools: function () {
    if (this.locked) {
      return [tools.ToolUnlock];
    }
    return [tools.ToolBorderColor, tools.ToolLock];
  },

  // Quack like a group.
  setOnObjects: function (key, value) {
    return this.set(key, value);
  },
  getObjects: function () {
    return [this];
  },
};

export default PathBehaviors;
